<template>
  <dl class="grid grid-cols-1 gap-y-8">
    <div>
      <dt class="text-sm font-medium text-gray-500">Estimated audience size</dt>
      <dd class="mt-1 text-sm text-gray-900">
        {{ estimatedSize }}
      </dd>
    </div>
    <div>
      <dt class="text-sm font-medium text-gray-500">Audience source</dt>
      <dd class="mt-1 text-sm text-gray-900">Google Ads</dd>
    </div>
    <div>
      <dt class="text-sm font-medium text-gray-500">Audience type</dt>
      <dd class="mt-1 text-sm text-gray-900">User list</dd>
    </div>
  </dl>
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  props: {
    audience: {
      type: Object,
      required: true,
    },
  },
  computed: {
    estimatedSize() {
      const displaySize = Number.parseInt(this.audience.model.size_for_display || 0, 10);
      const searchSize = Number.parseInt(this.audience.model.size_for_search || 0, 10);

      return Numbro(displaySize + searchSize).format({
        thousandSeparated: true,
      });
    },
  },
};
</script>
